import { __ } from "@wordpress/i18n";
import {
  InspectorControls,
  __experimentalUseMultipleOriginColorsAndGradients as useMultipleOriginColorsAndGradients,
  __experimentalColorGradientSettingsDropdown as ColorGradientSettingsDropdown,
} from "@wordpress/block-editor";
import {
  PanelBody,
  __experimentalBorderBoxControl as BorderBoxControl,
  __experimentalToolsPanelItem as ToolsPanelItem,
  __experimentalToolsPanel as ToolsPanel,
  ToggleControl,
} from "@wordpress/components";

import ShadowPicker from "../../../../../../Externals/Src/Gutenberg/CustomBoxShadow/ShadowComponent";

import "./style.scss";

export default function QuickViewProductInspectorControls({
  attributes,
  setAttributes,
  isModalOpen,
  setIsModalOpen,
  clientId,
}) {
  const colorGradientSettings = useMultipleOriginColorsAndGradients();
  const {
    popupBackdropColor = "",
    popupBackgroundColor = "",
    popupBorder = {},
    popupShadow = "",
  } = attributes?.style ?? {};

  return (
    <>
      <InspectorControls>
        <PanelBody title={__("Popup", "brandy-blocks")} initialOpen={true}>
          <ToggleControl
            label={__("Show Popup", "brandy-blocks")}
            checked={isModalOpen}
            onChange={(v) => setIsModalOpen(v)}
          />
        </PanelBody>
      </InspectorControls>

      <InspectorControls group="color">
        <ColorGradientSettingsDropdown
          settings={[
            {
              label: __("Backdrop color", "brandy-blocks"),
              colorValue: popupBackdropColor,
              clearable: true,
              onColorChange: (value) => {
                setAttributes({
                  style: {
                    ...(attributes.style ?? {}),
                    popupBackdropColor: value,
                  },
                });
              },
              resetAllFilter: (prev) => {
                prev.style.popupBackdropColor = undefined;
                return prev;
              },
            },
            {
              label: __("Modal background color", "brandy-blocks"),
              colorValue: popupBackgroundColor,
              clearable: true,
              onColorChange: (value) => {
                setAttributes({
                  style: {
                    ...(attributes.style ?? {}),
                    popupBackgroundColor: value,
                  },
                });
              },
              resetAllFilter: (prev) => {
                prev.style.popupBackgroundColor = undefined;
                return prev;
              },
            },
          ]}
          panelId={clientId}
          hasColorsOrGradients={false}
          disableCustomColors={false}
          __experimentalIsRenderedInSidebar
          {...colorGradientSettings}
        />
      </InspectorControls>
      <InspectorControls group="border">
        <ToolsPanelItem
          panelId={clientId}
          hasValue={() => Object.keys(popupBorder ?? {}).length > 0}
          label={__("Popup border")}
          onDeselect={() => {
            setAttributes({
              style: {
                ...(attributes.style ?? {}),
                popupBorder: {},
              },
            });
          }}
          resetAllFilter={(prev) => {
            prev.style.popupBorder = {};
            return prev;
          }}
          isShownByDefault={true}
        >
          <BorderBoxControl
            colors={colorGradientSettings?.colors ?? []}
            panelId={clientId}
            value={popupBorder}
            onChange={(v) => {
              setAttributes({
                style: {
                  ...(attributes.style ?? {}),
                  popupBorder: v,
                },
              });
            }}
            enableAlpha
            popoverOffset={40}
            popoverPlacement="left-start"
            __experimentalIsRenderedInSidebar
            size="__unstable-large"
            label={__("Popup border")}
          />
        </ToolsPanelItem>
        <ToolsPanelItem
          panelId={clientId}
          hasValue={() => !!popupShadow}
          label={__("Popup shadow", "brandy-blocks")}
          onDeselect={() => {
            setAttributes({
              style: {
                ...(attributes.style ?? {}),
                popupShadow: "",
              },
            });
          }}
          isShownByDefault={true}
          resetAllFilter={(prev) => {
            prev.style.popupShadow = "";
            return prev;
          }}
        >
          <ShadowPicker
            label={__("Popup shadow", "brandy-blocks")}
            shadow={popupShadow}
            onChange={(value) => {
              setAttributes({
                style: {
                  ...(attributes.style ?? {}),
                  popupShadow: value,
                },
              });
            }}
          />
        </ToolsPanelItem>
      </InspectorControls>
    </>
  );
}
